import React from 'react';

import * as Styled from '+/components/DonateForm/DonateForm.styles';

export const Disclosures = ({ controller }: { controller: EveryActionModelController }) => (
  <Styled.FinePrint>
    <p>
      By supporting The Humane League, you are agreeing to our{' '}
      <a href="https://thehumaneleague.org/privacy-policy" target="_blank" rel="noopener">
        Privacy Policy
      </a>
      .
    </p>
    <p>
      We value and respect our donors. Read our{' '}
      <a
        href="https://thehumaneleague.org/commitment-to-donors"
        target="_blank"
        rel="noopener noreferrer"
      >
        commitment to donors
      </a>
      .
    </p>
    <p>
      {controller.getCountry() === 'US' && (
        <>
          &nbsp;View{' '}
          <a
            href="https://thehumaneleague.org/state-disclosures"
            target="_blank"
            rel="noopener noreferrer"
          >
            State Disclosures
          </a>
          .
        </>
      )}
    </p>
  </Styled.FinePrint>
);
